module.exports = __webpack_public_path__ + "static/media/fondo_asesor_de_imagen.a6739337.jpg";